


// import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik'
// import React, { useEffect, useRef, useState } from 'react'
// import { BiTrash } from 'react-icons/bi'
// import { VscDiffAdded } from 'react-icons/vsc'
// import Swal from 'sweetalert2'
// import * as Yup from 'yup'
// import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios'
// import { config } from '../../CommonUtils/CommonURLS'
// import { ERROR_MSG } from '../../CommonUtils/contextVariables'
// import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts'
// import allowNumbersOnly from '../../CommonUtils/CommonValidations'

// function CourseIntakeDetails({ goNext }) {

//     const [program, setProgram] = useState([])
//     const hasFetchedData = useRef(false)
//     const [course, setCourse] = useState([]);
//     const [CourseCategory, setCourseCategory] = useState([]);
//     const [medium, setMedium] = useState([]);

//     // ── Report state ───────────────────────────────────────────────────────
//     const [reportData, setReportData] = useState([]);

//     // ── Lookup maps for displaying labels in report ────────────────────────
//     const [programMap, setProgramMap] = useState({});   // course_group_code → desc
//     // courseCategory & course names are fetched per-row on demand
//     const [catNameMap, setCatNameMap] = useState({});   // course_cat_id → name
//     const [courseNameMap, setCourseNameMap] = useState({});   // course_id     → name

//     // ── Validation ─────────────────────────────────────────────────────────
//     const validation = Yup.object().shape({
//         courseDetails: Yup.array().of(
//             Yup.object().shape({
//                 courseGropcode: Yup.string().required(ERROR_MSG),
//                 courseType: Yup.string().required(ERROR_MSG),
//                 courseId: Yup.string().required(ERROR_MSG),
//                 regSelf: Yup.string().required(ERROR_MSG),
//                 courseNocType: Yup.string().nullable(),
//                 intake: Yup.string().required(ERROR_MSG),
//                 acite: Yup.string().nullable(),
//             })
//         )
//     });

//     // ── Formik ─────────────────────────────────────────────────────────────
//     const formik = useFormik({
//         enableReinitialize: true,
//         initialValues: {
//             courseDetails: [{
//                 courseGropcode: '',
//                 courseType: '',
//                 courseId: '',
//                 regSelf: '',
//                 courseNocType: '',
//                 intake: '',
//                 acite: '',
//                 campusType: '',
//             }]
//         },
//         validationSchema: validation,
//         onSubmit: (val) => {
//             Swal.fire({
//                 text: 'Are you sure you want to submit?',
//                 icon: 'warning',
//                 showCancelButton: true,
//                 confirmButtonText: 'Yes, submit it!',
//                 cancelButtonText: 'No, cancel!',
//                 backdrop: false,
//             }).then((result) => {
//                 if (result.isConfirmed) {
//                     let url = config.url.FAC_URL + `saveCourseIntake`
//                     CommonAxiosPost(url, val).then((res) => {
//                         if (res?.data?.scode === '01') {
//                             successAlert2(res?.data?.sdesc);
//                             GetIntakeDetails();
//                             GetReportData();   // refresh report after save
//                             goNext();
//                         } else {
//                             failureAlert('Failed to Submit')
//                         }
//                     })
//                 }
//             })
//         }
//     });

//     // ── API helpers ────────────────────────────────────────────────────────
//     function GetProgram() {
//         let url = config.url.FAC_URL + `getCourseGroupList`
//         CommonAxiosGet(url).then((res) => {
//             if (res?.data?.scode === '01') {
//                 setProgram(res?.data?.getCourseGroupList);
//                 // build lookup map for report labels
//                 const map = {};
//                 res?.data?.getCourseGroupList?.forEach((p) => {
//                     map[p.course_group_code] = p.course_group_desc;
//                 });
//                 setProgramMap(map);
//             } else {
//                 setProgram([]);
//             }
//         });
//     }

//     function GetCourseCategory(program, index) {
//         if (!program) return;
//         try {
//             let url = `${config.url.FAC_URL}getCourseCategoryList/${program}`;
//             CommonAxiosGet(url).then((res) => {
//                 if (res?.data?.scode === '01') {
//                     // build lookup map for report labels
//                     const newMap = {};
//                     res?.data?.getCourseCategoryList?.forEach((ds) => {
//                         newMap[ds.course_cat_id] = ds.course_cat_name;
//                     });
//                     setCatNameMap((prev) => ({ ...prev, ...newMap }));

//                     let options = res?.data?.getCourseCategoryList?.map((ds, i) => (
//                         <option key={i} value={ds.course_cat_id}>{ds.course_cat_name}</option>
//                     ));
//                     setCourseCategory((prev) => ({ ...prev, [index]: options }));
//                 } else {
//                     setCourseCategory((prev) => ({ ...prev, [index]: [] }));
//                 }
//             });
//         } catch (err) {
//             console.error('Error fetching course categories:', err);
//         }
//     }

//     function GetCourses(CourseCategory, index) {
//         if (!CourseCategory) return;
//         try {
//             let url = config.url.FAC_URL + `getSpecilization/${CourseCategory}`
//             CommonAxiosGet(url).then((res) => {
//                 if (res?.data?.scode === '01') {
//                     // build lookup map for report labels
//                     const newMap = {};
//                     res?.data?.Specilization?.forEach((ds) => {
//                         newMap[ds.course_id] = ds.course_name;
//                     });
//                     setCourseNameMap((prev) => ({ ...prev, ...newMap }));

//                     let options = res?.data?.Specilization?.map((ds, i) => (
//                         <option key={i} value={ds.course_id}>{ds.course_name}</option>
//                     ));
//                     setCourse((prev) => ({ ...prev, [index]: options }));
//                 } else {
//                     setCourse((prev) => ({ ...prev, [index]: [] }));
//                 }
//             });
//         } catch (err) { }
//     }

//     function GetMediumList() {
//         CommonAxiosGet(`${config.url.FAC_URL}getMediumList`).then((res) => {
//             setMedium(res?.data?.scode === '01' ? res.data.getMediumList || [] : []);
//         });
//     }

//     function GetIntakeDetails() {
//         CommonAxiosGet(`${config.url.FAC_URL}getCourseIntakeList`).then((res) => {
//             if (res?.data?.scode === '01') {
//                 const list = res?.data?.list || [];
//                 if (list.length > 0) {
//                     const mappedData = list.map((item, index) => {
//                         GetCourseCategory(item?.course_group_code, index);
//                         GetCourses(item?.course_cat_id, index);
//                         return {
//                             courseGropcode: item?.course_group_code || '',
//                             courseType: item?.course_cat_id || '',
//                             courseId: item?.course_id || '',
//                             regSelf: item?.reg_self || '',
//                             courseNocType: item?.course_noc_type || '',
//                             intake: item?.intake || '',
//                             acite: item?.acite || '',
//                             campusType: '',
//                         };
//                     });
//                     formik.setFieldValue('courseDetails', mappedData);
//                 } else {
//                     formik.setFieldValue('courseDetails', [{
//                         courseGropcode: '', courseType: '', courseId: '',
//                         regSelf: '', courseNocType: '', intake: '', acite: '', campusType: ''
//                     }]);
//                 }
//             } else {
//                 formik.setFieldValue('courseDetails', [{
//                     courseGropcode: '', courseType: '', courseId: '',
//                     regSelf: '', courseNocType: '', intake: '', acite: '', campusType: ''
//                 }]);
//             }
//         });
//     }

//     // ── Report: fetch saved records for display ────────────────────────────
//     function GetReportData() {
//         CommonAxiosGet(`${config.url.FAC_URL}getCourseIntakeList`).then((res) => {
//             if (res?.data?.scode === '01') {
//                 const list = res?.data?.list || [];
//                 setReportData(list);
//                 // Pre-fetch category and course names for all rows so labels show in report
//                 list.forEach((item) => {
//                     if (item?.course_group_code) {
//                         // fetch category names
//                         CommonAxiosGet(`${config.url.FAC_URL}getCourseCategoryList/${item.course_group_code}`)
//                             .then((r) => {
//                                 if (r?.data?.scode === '01') {
//                                     const newMap = {};
//                                     r?.data?.getCourseCategoryList?.forEach((ds) => {
//                                         newMap[ds.course_cat_id] = ds.course_cat_name;
//                                     });
//                                     setCatNameMap((prev) => ({ ...prev, ...newMap }));
//                                 }
//                             });
//                     }
//                     if (item?.course_cat_id) {
//                         // fetch course names
//                         CommonAxiosGet(`${config.url.FAC_URL}getSpecilization/${item.course_cat_id}`)
//                             .then((r) => {
//                                 if (r?.data?.scode === '01') {
//                                     const newMap = {};
//                                     r?.data?.Specilization?.forEach((ds) => {
//                                         newMap[ds.course_id] = ds.course_name;
//                                     });
//                                     setCourseNameMap((prev) => ({ ...prev, ...newMap }));
//                                 }
//                             });
//                     }
//                 });
//             } else {
//                 setReportData([]);
//             }
//         });
//     }

//     useEffect(() => {
//         if (!hasFetchedData.current) {
//             GetProgram();
//             GetMediumList();
//             GetIntakeDetails();
//             GetReportData();
//             hasFetchedData.current = true;
//         }
//     }, []);

//     const handleRemoveRow = (data, index) => {
//         const updatedCourseCategory = { ...CourseCategory };
//         delete updatedCourseCategory[index];
//         const rearrangeCourseType = Object.values(updatedCourseCategory).reduce((acc, item, i) => {
//             acc[i] = item; return acc;
//         }, {});
//         setCourseCategory(rearrangeCourseType);

//         const updatedCourse = { ...course };
//         delete updatedCourse[index];
//         const rearrangeCourse = Object.values(updatedCourse).reduce((acc, item, i) => {
//             acc[i] = item; return acc;
//         }, {});
//         setCourse(rearrangeCourse);

//         formik.setFieldValue('noOfCourses', parseInt(formik.values.noOfCourses) - 1);
//         data.remove(index);
//     };

//     // ── Label helpers for report ───────────────────────────────────────────
//     const regSelfLabel = (val) => {
//         const map = { R: 'Regular', S: 'Self-Financed', SS: 'Self Support' };
//         return map[val] || val || '—';
//     };

//     const nocTypeLabel = (val) => val || '—';
//     const aciteLabel = (val) => val || '—';

//     // ── Render ─────────────────────────────────────────────────────────────
//     return (
//         <>
//             <div className="faculty-form-wrapper">
//                 <div className="faculty-card">


//                     {/* <h5 className="mb-3 innerheader-new"><span>Course Intake Details</span></h5>

//                     <FormikProvider value={formik}>
//                         <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form">

//                             <div className="table-responsive mt-3">
//                                 <table className="table table-bordered mt-2">
//                                     <thead className="table-primary">
//                                         <tr>
//                                             <th>SNO</th>
//                                             <th>Academic Program Type</th>
//                                             <th>Course / Program</th>
//                                             <th>Branch / Specialization</th>
//                                             <th>Regular / Self-Financed</th>
//                                             <th>Permanent / Temporary Affiliation</th>
//                                             <th>Approved Intake</th>
//                                             <th>AICTE App. Ref</th>
//                                             <th>Action</th>
//                                         </tr>
//                                     </thead>

//                                     <tbody>
//                                         <FieldArray name="courseDetails">
//                                             {(arrayHelpers) => (
//                                                 <>
//                                                     {formik?.values?.courseDetails?.map((row, index) => (
//                                                         <tr key={index}>

//                                                             <td className="text-center">{index + 1}</td>

//                                                             <td>
//                                                                 <Field as="select" className="select-input"
//                                                                     name={`courseDetails[${index}].courseGropcode`}
//                                                                     onChange={(e) => {
//                                                                         const value = e.target.value;
//                                                                         formik.setFieldValue(`courseDetails[${index}].courseGropcode`, value);
//                                                                         formik.setFieldValue(`courseDetails[${index}].courseType`, '');
//                                                                         formik.setFieldValue(`courseDetails[${index}].courseId`, '');
//                                                                         GetCourseCategory(value, index);
//                                                                     }}>
//                                                                     <option value="">--Select--</option>
//                                                                     {program.map((p, i) => (
//                                                                         <option key={i} value={p.course_group_code}>{p.course_group_desc}</option>
//                                                                     ))}
//                                                                 </Field>
//                                                                 <ErrorMessage name={`courseDetails[${index}].courseGropcode`} component="div" className="text-danger small" />
//                                                             </td>

//                                                             <td>
//                                                                 <Field as="select" className="select-input"
//                                                                     name={`courseDetails[${index}].courseType`}
//                                                                     onChange={(e) => {
//                                                                         const value = e.target.value;
//                                                                         formik.setFieldValue(`courseDetails[${index}].courseType`, value);
//                                                                         formik.setFieldValue(`courseDetails[${index}].courseId`, '');
//                                                                         GetCourses(value, index);
//                                                                     }}>
//                                                                     <option value="">--Select--</option>
//                                                                     {CourseCategory[index]}
//                                                                 </Field>
//                                                                 <ErrorMessage name={`courseDetails[${index}].courseType`} component="div" className="text-danger small" />
//                                                             </td>

//                                                             <td>
//                                                                 <Field as="select" className="select-input" name={`courseDetails[${index}].courseId`}>
//                                                                     <option value="">--Select--</option>
//                                                                     {course[index]}
//                                                                 </Field>
//                                                                 <ErrorMessage name={`courseDetails[${index}].courseId`} component="div" className="text-danger small" />
//                                                             </td>

//                                                             <td>
//                                                                 <Field as="select" className="select-input" name={`courseDetails[${index}].regSelf`}>
//                                                                     <option value="">--Select--</option>
//                                                                     <option value="R">Regular</option>
//                                                                     <option value="S">Self-Financed</option>
//                                                                     <option value="SS">Self Support</option>
//                                                                 </Field>
//                                                                 <ErrorMessage name={`courseDetails[${index}].regSelf`} component="div" className="text-danger small" />
//                                                             </td>

//                                                             <td>
//                                                                 <Field as="select" className="select-input" name={`courseDetails[${index}].courseNocType`}>
//                                                                     <option value="">--Select--</option>
//                                                                     <option value="Permanent">Permanent</option>
//                                                                     <option value="Temporary">Temporary</option>
//                                                                     <option value="Conditional">Conditional</option>
//                                                                 </Field>
//                                                                 <ErrorMessage name={`courseDetails[${index}].courseNocType`} component="div" className="text-danger small" />
//                                                             </td>

//                                                             <td>
//                                                                 <Field type="text" name={`courseDetails[${index}].intake`}
//                                                                     className="form-control" maxLength={5} onKeyPress={allowNumbersOnly} />
//                                                                 <ErrorMessage name={`courseDetails[${index}].intake`} component="div" className="text-danger small" />
//                                                             </td>

//                                                             <td>
//                                                                 <Field as="select" className="select-input" name={`courseDetails[${index}].acite`}>
//                                                                     <option value="">--Select--</option>
//                                                                     <option value="AICTE">AICTE</option>
//                                                                     <option value="CHE">CHE</option>
//                                                                     <option value="BCI">BCI</option>
//                                                                     <option value="PCI">PCI</option>
//                                                                 </Field>
//                                                                 <ErrorMessage name={`courseDetails[${index}].acite`} component="div" className="text-danger small" />
//                                                             </td>

//                                                             <td className="text-center">
//                                                                 {index === 0 && (
//                                                                     <button type="button" className="btn btn-success btn-sm"
//                                                                         onClick={() => arrayHelpers.push({
//                                                                             courseGropcode: '', courseType: '', courseId: '',
//                                                                             regSelf: '', courseNocType: '', intake: '', acite: '', campusType: ''
//                                                                         })}>
//                                                                         <VscDiffAdded />
//                                                                     </button>
//                                                                 )}
//                                                                 {index !== 0 && (
//                                                                     <button type="button" className="btn btn-danger btn-sm"
//                                                                         onClick={() => handleRemoveRow(arrayHelpers, index)}>
//                                                                         <BiTrash />
//                                                                     </button>
//                                                                 )}
//                                                             </td>

//                                                         </tr>
//                                                     ))}
//                                                 </>
//                                             )}
//                                         </FieldArray>
//                                     </tbody>
//                                 </table>
//                             </div>

//                             <button type="submit" className="btn btn-success btn-sm float-end mt-3">Save</button>
//                             <br /><br /><br />

//                         </Form>
//                     </FormikProvider> */}

//                     {/* ════════════════════════════════════════════════════
//                         REPORT — Existing Saved Records
//                     ════════════════════════════════════════════════════ */}
//                     {/* <hr className="mt-5" > */}
//                     <h5 className="mb-3 innerheader-new mt-4">
//                         <span> List of UG Courses </span>
//                     </h5>


//                     <div className="table-responsive mt-2">
//                         <table className="table table-bordered table-hover mt-2">
//                             <thead className="table-success">
//                                 <tr>
//                                     <th>S.No</th>
//                                     {/* <th>Academic Program Type</th> */}
//                                     <th>Course / Program</th>
//                                     <th>Branch / Specialization</th>
//                                     <th>Regular / Self-Financed</th>
//                                     <th>Approved Intake</th>

//                                     <th>Affiliation Type</th>
//                                     {/* <th>AICTE App. Ref</th> */}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {reportData.map((item, index) => (
//                                     <tr key={index}>
//                                         <td className="text-center">{index + 1}</td>
//                                         {/* <td>{programMap[item?.course_group_code] || item?.course_group_code || '—'}</td> */}
//                                         <td>{catNameMap[item?.course_cat_id] || item?.course_cat_id || '—'}</td>
//                                         <td>{courseNameMap[item?.course_id] || item?.course_id || '—'}</td>
//                                         <td>{regSelfLabel(item?.reg_self)}</td>
//                                         <td className="text-center">{item?.intake || '—'}</td>

//                                         <td>{nocTypeLabel(item?.course_noc_type)}</td>
//                                         {/* <td>{aciteLabel(item?.acite)}</td> */}
//                                     </tr>
//                                 ))}
//                             </tbody>
//                             <tfoot className="table-light">
//                                 <tr>
//                                     <td colSpan={5} className="text-end fw-bold">Total Approved Intake:</td>
//                                     <td className="text-center fw-bold">
//                                         {reportData.reduce((sum, item) => sum + (parseInt(item?.intake) || 0), 0)}
//                                     </td>
//                                     <td></td>
//                                 </tr>
//                             </tfoot>
//                         </table>
//                     </div>


//                 </div>
//             </div>
//         </>
//     );
// }

// export default CourseIntakeDetails;


// import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik'
// import React, { useEffect, useRef, useState } from 'react'
// import { BiTrash } from 'react-icons/bi'
// import { VscDiffAdded } from 'react-icons/vsc'
// import Swal from 'sweetalert2'
// import * as Yup from 'yup'
// // import allowNumbersOnly, { handlePaste } from '../../CommonUtils/CommonValidations'
// import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios'
// import { config } from '../../CommonUtils/CommonURLS'
// import { ERROR_MSG } from '../../CommonUtils/contextVariables'
// import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts'
// import allowNumbersOnly from '../../CommonUtils/CommonValidations'

// function CourseIntakeDetails({ goNext }) {

//     const [program, setProgram] = useState([])
//     const hasFetchedData = useRef(false)
//     const [course, setCourse] = useState([]);
//     const [CourseCategory, setCourseCategory] = useState([]);

//     const validation = Yup.object().shape({
//         courseDetails: Yup.array().of(
//             Yup.object().shape({
//                 courseGropcode: Yup.string().required(ERROR_MSG),
//                 courseType: Yup.string().required(ERROR_MSG),
//                 courseId: Yup.string().required(ERROR_MSG),
//                 // mediumCode: Yup.string().required(ERROR_MSG),
//                 regSelf: Yup.string().required(ERROR_MSG),
//                 courseNocType: Yup.string().nullable(),
//                 intake: Yup.string().required(ERROR_MSG),
//                 acite: Yup.string().nullable(),
//             })
//         )
//     });
//     const formik = useFormik({
//         enableReinitialize: true,
//         initialValues: {

//             courseDetails: [{
//                 courseGropcode: '',
//                 courseType: '',
//                 courseId: '',
//                 // mediumCode: '',
//                 regSelf: '',
//                 courseNocType: '',
//                 intake: '',
//                 acite: "",

//                 campusType: '',
//             }]
//         },
//         validationSchema: validation,
//         onSubmit: (val) => {
//             Swal.fire({
//                 text: 'Are you sure you want to submit?',
//                 icon: 'warning',
//                 showCancelButton: true,
//                 confirmButtonText: 'Yes, submit it!',
//                 cancelButtonText: 'No, cancel!',
//                 backdrop: false,
//             }).then((result) => {
//                 if (result.isConfirmed) {
//                     let url = config.url.FAC_URL + `saveCourseIntake`
//                     CommonAxiosPost(url, val).then((res) => {
//                         if (res?.data?.scode === '01') {

//                             successAlert2(res?.data?.sdesc);
//                             GetIntakeDetails();

//                             goNext();


//                         }
//                         else {
//                             failureAlert('Failed to Submit')
//                         }
//                     })
//                 }
//             })

//         }
//     })



//     function GetProgram() {
//         let url = config.url.FAC_URL + `getCourseGroupList`
//         CommonAxiosGet(url).then((res) => {
//             if (res?.data?.scode === '01') {
//                 setProgram(res?.data?.getCourseGroupList)
//             }
//             else {
//                 setProgram([])
//             }
//         })
//     }

//     function GetCourseCategory(program, index) {
//         if (!program) {
//             console.log("Invalid program value:", program);
//             return;
//         }

//         try {
//             let url = `${config.url.FAC_URL}getCourseCategoryList/${program}`;
//             CommonAxiosGet(url).then((res) => {
//                 if (res?.data?.scode === '01') {
//                     let options = res?.data?.getCourseCategoryList?.map((ds, i) => (
//                         <option key={i} value={ds.course_cat_id}>{ds.course_cat_name}</option>
//                     ));
//                     setCourseCategory((prevState) => ({
//                         ...prevState,
//                         [index]: options,
//                     }));
//                 } else {
//                     setCourseCategory((prevState) => ({
//                         ...prevState,
//                         [index]: [],
//                     }));
//                 }
//             });
//         } catch (err) {
//             console.error("Error fetching course categories:", err);
//         }
//     }

//     function GetCourses(CourseCategory, index) {
//         if (!CourseCategory) {
//             return;
//         }
//         try {
//             let url = config.url.FAC_URL + `getSpecilization/${CourseCategory}`
//             CommonAxiosGet(url).then((res) => {
//                 if (res?.data?.scode === '01') {
//                     let options = res?.data?.Specilization?.map((ds, i) => {
//                         return (
//                             <option key={i} value={ds.course_id}>{ds.course_name}</option>
//                         );
//                     });
//                     setCourse((prevState) => ({
//                         ...prevState,
//                         [index]: options,
//                     }));
//                 }
//                 else {
//                     setCourse((prevState) => ({
//                         ...prevState,
//                         [index]: [],
//                     }));
//                 }
//             })
//         } catch (err) { }
//     }
//     const [medium, setMedium] = useState([]);

//     function GetMediumList() {
//         CommonAxiosGet(`${config.url.FAC_URL}getMediumList`).then((res) => {
//             setMedium(res?.data?.scode === "01" ? res.data.getMediumList || [] : []);
//         });
//     }




//     function GetIntakeDetails() {

//         CommonAxiosGet(`${config.url.FAC_URL}getCourseIntakeList`).then((res) => {

//             if (res?.data?.scode === "01") {

//                 const list = res?.data?.list || [];

//                 if (list.length > 0) {

//                     const mappedData = list.map((item, index) => {

//                         GetCourseCategory(item?.course_group_code, index);
//                         GetCourses(item?.course_cat_id, index);

//                         return {
//                             courseGropcode: item?.course_group_code || "",
//                             courseType: item?.course_cat_id || "",
//                             courseId: item?.course_id || "",
//                             // mediumCode: item?.medium_code || "",
//                             regSelf: item?.reg_self || "",
//                             courseNocType: item?.course_noc_type || "",
//                             intake: item?.intake || "",
//                             acite: item?.acite || '',
//                             campusType: ""
//                         };

//                     });

//                     formik.setFieldValue("courseDetails", mappedData);

//                 } else {

//                     // ✅ If no API data, keep one empty row
//                     formik.setFieldValue("courseDetails", [
//                         {
//                             courseGropcode: "",
//                             courseType: "",
//                             courseId: "",
//                             // mediumCode: "",
//                             regSelf: "",
//                             courseNocType: "",
//                             intake: "",
//                             acite: "",
//                             campusType: ""
//                         }
//                     ]);

//                 }

//             } else {

//                 // ✅ If API fails also keep one row
//                 formik.setFieldValue("courseDetails", [
//                     {
//                         courseGropcode: "",
//                         courseType: "",
//                         courseId: "",
//                         // mediumCode: "",
//                         regSelf: "",
//                         courseNocType: "",
//                         intake: "",
//                         acite: "",
//                         campusType: ""
//                     }
//                 ]);

//             }

//         });

//     }

//     useEffect(() => {

//         if (!hasFetchedData.current) {
//             GetProgram()
//             GetMediumList();
//             GetIntakeDetails();
//             hasFetchedData.current = true
//         }
//     }, [])

//     const handleRemoveRow = (data, index) => {


//         const updatedCourseCategory = { ...CourseCategory };
//         delete updatedCourseCategory[index];

//         const rearrangeCourseType = Object.values(updatedCourseCategory).reduce((acc, item, index) => {
//             acc[index] = item;
//             return acc;
//         }, {});

//         setCourseCategory(rearrangeCourseType);

//         //course, setCourse
//         const updatedCourse = { ...course };
//         delete updatedCourse[index];//1//

//         const rearrangeCourse = Object.values(updatedCourse).reduce((acc, item, index) => {
//             acc[index] = item;
//             return acc;
//         }, {});

//         setCourse(rearrangeCourse);


//         // Remove the row
//         formik.setFieldValue('noOfCourses', parseInt(formik.values.noOfCourses) - 1);
//         data.remove(index);
//     };



//     return (
//         <>
//             <div className="faculty-form-wrapper">
//                 <div className="faculty-card">
//                     <h5 className="mb-3 innerheader-new"><span>Course Intake Details</span></h5>


//                     <FormikProvider value={formik}>
//                         <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form" >

//                             <div className="table-responsive mt-3">
//                                 <table className="table table-bordered mt-2 ">

//                                     <thead className="table-primary">
//                                         <tr>
//                                             <th>SNO</th>
//                                             <th>Academic Program Type</th>
//                                             <th>Course /Program</th>
//                                             <th>Branch /Specialization</th>
//                                             <th>Regular/Self-Financed</th>
//                                             <th> Permanent/ Temporary Affiliation</th>
//                                             <th>Approved Intake</th>
//                                             <th> 	AICTE App. Ref</th>
//                                             <th>Action</th>
//                                         </tr>
//                                     </thead>


//                                     <tbody>
//                                         <FieldArray name="courseDetails">
//                                             {(arrayHelpers) => (
//                                                 <>
//                                                     {formik?.values?.courseDetails?.map((row, index) => (
//                                                         <tr key={index}>

//                                                             <td className="text-center">{index + 1}</td>

//                                                             {/* PROGRAM */}
//                                                             <td>
//                                                                 <Field
//                                                                     as="select"
//                                                                     className="select-input" name={`courseDetails[${index}].courseGropcode`}
//                                                                     onChange={(e) => {

//                                                                         const value = e.target.value;

//                                                                         formik.setFieldValue(`courseDetails[${index}].courseGropcode`, value);
//                                                                         formik.setFieldValue(`courseDetails[${index}].courseType`, "");
//                                                                         formik.setFieldValue(`courseDetails[${index}].courseId`, "");

//                                                                         GetCourseCategory(value, index);

//                                                                     }}
//                                                                 >

//                                                                     <option value="">--Select--</option>

//                                                                     {program.map((p, i) => (
//                                                                         <option key={i} value={p.course_group_code}>
//                                                                             {p.course_group_desc}
//                                                                         </option>
//                                                                     ))}

//                                                                 </Field>

//                                                                 <ErrorMessage
//                                                                     name={`courseDetails[${index}].courseGropcode`}
//                                                                     component="div"
//                                                                     className="text-danger small"
//                                                                 />

//                                                             </td>

//                                                             {/* COURSE CATEGORY */}
//                                                             <td>

//                                                                 <Field
//                                                                     as="select"
//                                                                     className="select-input"
//                                                                     name={`courseDetails[${index}].courseType`}
//                                                                     onChange={(e) => {

//                                                                         const value = e.target.value;

//                                                                         formik.setFieldValue(`courseDetails[${index}].courseType`, value);
//                                                                         formik.setFieldValue(`courseDetails[${index}].courseId`, "");

//                                                                         GetCourses(value, index);

//                                                                     }}
//                                                                 >

//                                                                     <option value="">--Select--</option>
//                                                                     {CourseCategory[index]}

//                                                                 </Field>

//                                                                 <ErrorMessage
//                                                                     name={`courseDetails[${index}].courseType`}
//                                                                     component="div"
//                                                                     className="text-danger small"
//                                                                 />

//                                                             </td>

//                                                             {/* COURSE */}
//                                                             <td>

//                                                                 <Field
//                                                                     as="select"
//                                                                     className="select-input"
//                                                                     name={`courseDetails[${index}].courseId`}
//                                                                 >

//                                                                     <option value="">--Select--</option>
//                                                                     {course[index]}

//                                                                 </Field>

//                                                                 <ErrorMessage
//                                                                     name={`courseDetails[${index}].courseId`}
//                                                                     component="div"
//                                                                     className="text-danger small"
//                                                                 />

//                                                             </td>

//                                                             {/* MEDIUM */}
//                                                             {/* <td>

//                                                                 <Field
//                                                                     as="select"
//                                                                     className="form-control"
//                                                                     name={`courseDetails[${index}].mediumCode`}
//                                                                 >

//                                                                     <option value="">--Select--</option>

//                                                                     {medium.map((m, i) => (
//                                                                         <option key={i} value={m.medium_code}>
//                                                                             {m.name}
//                                                                         </option>
//                                                                     ))}

//                                                                 </Field>

//                                                                 <ErrorMessage
//                                                                     name={`courseDetails[${index}].mediumCode`}
//                                                                     component="div"
//                                                                     className="text-danger small"
//                                                                 />

//                                                             </td> */}

//                                                             {/* REG / SELF */}
//                                                             <td>

//                                                                 <Field
//                                                                     as="select"
//                                                                     className="select-input"
//                                                                     name={`courseDetails[${index}].regSelf`}
//                                                                 >

//                                                                     <option value="">--Select--</option>
//                                                                     <option value="R">Regular</option>
//                                                                     <option value="S">Self-Financed</option>
//                                                                     <option value="SS">Self Support</option>

//                                                                 </Field>

//                                                                 <ErrorMessage
//                                                                     name={`courseDetails[${index}].regSelf`}
//                                                                     component="div"
//                                                                     className="text-danger small"
//                                                                 />

//                                                             </td>

//                                                             {/* NOC TYPE */}
//                                                             <td>

//                                                                 <Field
//                                                                     as="select"
//                                                                     className="select-input"
//                                                                     name={`courseDetails[${index}].courseNocType`}
//                                                                 >

//                                                                     <option value="">--Select--</option>
//                                                                     <option value="Permanent">Permanent</option>
//                                                                     <option value="Temporary">Temporary</option>
//                                                                     <option value="Conditional">Conditional</option>

//                                                                 </Field>

//                                                                 <ErrorMessage
//                                                                     name={`courseDetails[${index}].courseNocType`}
//                                                                     component="div"
//                                                                     className="text-danger small"
//                                                                 />

//                                                             </td>

//                                                             {/* INTAKE */}
//                                                             <td>

//                                                                 <Field
//                                                                     type="text"
//                                                                     name={`courseDetails[${index}].intake`}
//                                                                     className="form-control"
//                                                                     maxLength={5}
//                                                                     onKeyPress={allowNumbersOnly}
//                                                                 />

//                                                                 <ErrorMessage
//                                                                     name={`courseDetails[${index}].intake`}
//                                                                     component="div"
//                                                                     className="text-danger small"
//                                                                 />

//                                                             </td>
//                                                             <td>

//                                                                 <Field
//                                                                     as="select"
//                                                                     className="select-input"
//                                                                     name={`courseDetails[${index}].acite`}
//                                                                 >

//                                                                     <option value="">--Select--</option>
//                                                                     <option value="AICTE"> AICTE </option>
//                                                                     <option value="CHE"> CHE </option>
//                                                                     <option value="BCI">BCI  </option>
//                                                                     <option value="PCI"> PCI </option>


//                                                                 </Field>

//                                                                 <ErrorMessage
//                                                                     name={`courseDetails[${index}].acite`}
//                                                                     component="div"
//                                                                     className="text-danger small"
//                                                                 />

//                                                             </td>

//                                                             {/* ACTION */}
//                                                             <td className="text-center">

//                                                                 {/* ADD ROW */}
//                                                                 {index === 0 && (

//                                                                     <button
//                                                                         type="button"
//                                                                         className="btn btn-success btn-sm"
//                                                                         onClick={() =>
//                                                                             arrayHelpers.push({
//                                                                                 courseGropcode: "",
//                                                                                 courseType: "",
//                                                                                 courseId: "",
//                                                                                 // mediumCode: "",
//                                                                                 regSelf: "",
//                                                                                 courseNocType: "",
//                                                                                 intake: "",
//                                                                                 acite: "",
//                                                                                 campusType: ""
//                                                                             })
//                                                                         }
//                                                                     >

//                                                                         <VscDiffAdded />

//                                                                     </button>

//                                                                 )}

//                                                                 {/* REMOVE ROW */}
//                                                                 {index !== 0 && (

//                                                                     <button
//                                                                         type="button"
//                                                                         className="btn btn-danger btn-sm"
//                                                                         onClick={() => arrayHelpers.remove(index)}
//                                                                     >

//                                                                         <BiTrash />

//                                                                     </button>

//                                                                 )}

//                                                             </td>

//                                                         </tr>
//                                                     ))}
//                                                 </>
//                                             )}
//                                         </FieldArray>
//                                     </tbody>
//                                 </table>
//                             </div>
//                             <button type='submit' className='btn btn-success btn-sm float-end mt-3'>  Save </button><pre /><pre /><pre />
//                         </Form>
//                     </FormikProvider>
//                 </div>
//             </div>
//         </>
//     )
// }

// export default CourseIntakeDetails


import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { BiTrash } from 'react-icons/bi'
import { VscDiffAdded } from 'react-icons/vsc'
import Swal from 'sweetalert2'
import * as Yup from 'yup'
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios'
import { config } from '../../CommonUtils/CommonURLS'
import { ERROR_MSG } from '../../CommonUtils/contextVariables'
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts'
import allowNumbersOnly from '../../CommonUtils/CommonValidations'

function CourseIntakeDetails({ goNext, paymentDone, onSaved }) {
    console.log("CourseIntakeDetails", paymentDone);
    const Clg = sessionStorage?.getItem("LOGIN");

    const [program, setProgram] = useState([])
    const hasFetchedData = useRef(false)
    const [course, setCourse] = useState([]);
    const [CourseCategory, setCourseCategory] = useState([]);
    const [medium, setMedium] = useState([]);

    // ── Report state ───────────────────────────────────────────────────────
    const [reportData, setReportData] = useState([]);
    const [ugReportData, setUgReportData] = useState([]);
    const [pgReportData, setPgReportData] = useState([]);
    // ── Lookup maps for displaying labels in report ────────────────────────
    const [programMap, setProgramMap] = useState({});   // course_group_code → desc
    // courseCategory & course names are fetched per-row on demand
    const [catNameMap, setCatNameMap] = useState({});   // course_cat_id → name
    const [courseNameMap, setCourseNameMap] = useState({});   // course_id     → name

    // ── Validation ─────────────────────────────────────────────────────────
    const validation = Yup.object().shape({
        courseDetails: Yup.array().of(
            Yup.object().shape({
                sectionNo: Yup.string().required(ERROR_MSG),

            })
        )
    });

    // ── Formik ─────────────────────────────────────────────────────────────
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            courseDetails: ugReportData?.map((item) => ({
                courseGropcode: item.course_group_code || "",
                courseType: item.course_cat_id || "",
                courseId: item.course_id || "",
                regSelf: item.reg_self || "",
                courseNocType: item.course_noc_type || "",
                intake: item.intake || "",
                acite: item.ac_year || "",
                campusType: "",
                sectionNo: item.section_no || "" // 👈 important
            }))
        },
        validationSchema: validation,
        onSubmit: (val) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.FAC_URL + `saveCourseIntake`
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetIntakeDetails();
                            GetReportData();
                            onSaved && onSaved();   // refresh report after save
                            goNext();
                        } else {
                            failureAlert('Failed to Submit')
                        }
                    })
                }
            })
        }
    });

    // ── API helpers ────────────────────────────────────────────────────────
    function GetProgram() {
        let url = config.url.FAC_URL + `getCourseGroupList`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setProgram(res?.data?.getCourseGroupList);
                // build lookup map for report labels
                const map = {};
                res?.data?.getCourseGroupList?.forEach((p) => {
                    map[p.course_group_code] = p.course_group_desc;
                });
                setProgramMap(map);
            } else {
                setProgram([]);
            }
        });
    }

    function GetCourseCategory(program, index) {
        if (!program) return;
        try {
            let url = `${config.url.FAC_URL}getCourseCategoryList/${program}`;
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.scode === '01') {
                    // build lookup map for report labels
                    const newMap = {};
                    res?.data?.getCourseCategoryList?.forEach((ds) => {
                        newMap[ds.course_cat_id] = ds.course_cat_name;
                    });
                    setCatNameMap((prev) => ({ ...prev, ...newMap }));

                    let options = res?.data?.getCourseCategoryList?.map((ds, i) => (
                        <option key={i} value={ds.course_cat_id}>{ds.course_cat_name}</option>
                    ));
                    setCourseCategory((prev) => ({ ...prev, [index]: options }));
                } else {
                    setCourseCategory((prev) => ({ ...prev, [index]: [] }));
                }
            });
        } catch (err) {
            console.error('Error fetching course categories:', err);
        }
    }

    function GetCourses(CourseCategory, index) {
        if (!CourseCategory) return;
        try {
            let url = config.url.FAC_URL + `getSpecilization/${CourseCategory}`
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.scode === '01') {
                    // build lookup map for report labels
                    const newMap = {};
                    res?.data?.Specilization?.forEach((ds) => {
                        newMap[ds.course_id] = ds.course_name;
                    });
                    setCourseNameMap((prev) => ({ ...prev, ...newMap }));

                    let options = res?.data?.Specilization?.map((ds, i) => (
                        <option key={i} value={ds.course_id}>{ds.course_name}</option>
                    ));
                    setCourse((prev) => ({ ...prev, [index]: options }));
                } else {
                    setCourse((prev) => ({ ...prev, [index]: [] }));
                }
            });
        } catch (err) { }
    }

    function GetMediumList() {
        CommonAxiosGet(`${config.url.FAC_URL}getMediumList`).then((res) => {
            setMedium(res?.data?.scode === '01' ? res.data.getMediumList || [] : []);
        });
    }

    function GetIntakeDetails() {
        CommonAxiosGet(`${config.url.FAC_URL}getCourseIntakeList`).then((res) => {
            if (res?.data?.scode === '01') {
                const list = res?.data?.list || [];
                if (list.length > 0) {
                    const mappedData = list.map((item, index) => {
                        GetCourseCategory(item?.course_group_code, index);
                        GetCourses(item?.course_cat_id, index);
                        return {
                            courseGropcode: item?.course_group_code || '',
                            courseType: item?.course_cat_id || '',
                            courseId: item?.course_id || '',
                            regSelf: item?.reg_self || '',
                            courseNocType: item?.course_noc_type || '',
                            intake: item?.intake || '',
                            acite: item?.acite || '',
                            campusType: '',
                        };
                    });
                    formik.setFieldValue('courseDetails', mappedData);
                } else {
                    formik.setFieldValue('courseDetails', [{
                        courseGropcode: '', courseType: '', courseId: '',
                        regSelf: '', courseNocType: '', intake: '', acite: '', campusType: ''
                    }]);
                }
            } else {
                formik.setFieldValue('courseDetails', [{
                    courseGropcode: '', courseType: '', courseId: '',
                    regSelf: '', courseNocType: '', intake: '', acite: '', campusType: ''
                }]);
            }
        });
    }

    const noUG = !(ugReportData?.length > 0);
    const noPG = !(pgReportData?.length > 0);
    function GetReportData() {
        CommonAxiosGet(`${config.url.FAC_URL}getCourseIntakeList`).then((res) => {
            if (res?.data?.scode === '01') {
                const list = res?.data?.list || [];

                const ugList = list.filter(item =>
                    item?.course_group_desc?.toUpperCase().startsWith("DEGREE")
                );

                const pgList = list.filter(item =>
                    item?.course_group_desc?.toUpperCase().startsWith("PG")
                );
                console.log("UG List:", ugList);
                console.log("PG List:", pgList);
                setUgReportData(ugList);
                setPgReportData(pgList);
                list?.forEach((item) => {
                    if (item?.course_group_code) {
                        CommonAxiosGet(`${config.url.FAC_URL}getCourseCategoryList/${item.course_group_code}`)
                            .then((r) => {
                                if (r?.data?.scode === '01') {
                                    const newMap = {};
                                    r?.data?.getCourseCategoryList?.forEach((ds) => {
                                        newMap[ds.course_cat_id] = ds.course_cat_name;
                                    });
                                    setCatNameMap((prev) => ({ ...prev, ...newMap }));
                                }
                            });
                    }
                    if (item?.course_cat_id) {
                        CommonAxiosGet(`${config.url.FAC_URL}getSpecilization/${item.course_cat_id}`)
                            .then((r) => {
                                if (r?.data?.scode === '01') {
                                    const newMap = {};
                                    r?.data?.Specilization?.forEach((ds) => {
                                        newMap[ds.course_id] = ds.course_name;
                                    });
                                    setCourseNameMap((prev) => ({ ...prev, ...newMap }));
                                }
                            });
                    }
                });
            } else {
                setUgReportData([]);
                setPgReportData([]);
            }
        });
    }


    useEffect(() => {
        if (!hasFetchedData.current) {
            GetProgram();
            GetMediumList();
            GetIntakeDetails();
            GetReportData();
            hasFetchedData.current = true;
        }
    }, []);

    const handleRemoveRow = (data, index) => {
        const updatedCourseCategory = { ...CourseCategory };
        delete updatedCourseCategory[index];
        const rearrangeCourseType = Object.values(updatedCourseCategory).reduce((acc, item, i) => {
            acc[i] = item; return acc;
        }, {});
        setCourseCategory(rearrangeCourseType);

        const updatedCourse = { ...course };
        delete updatedCourse[index];
        const rearrangeCourse = Object.values(updatedCourse).reduce((acc, item, i) => {
            acc[i] = item; return acc;
        }, {});
        setCourse(rearrangeCourse);

        formik.setFieldValue('noOfCourses', parseInt(formik.values.noOfCourses) - 1);
        data.remove(index);
    };

    // ── Label helpers for report ───────────────────────────────────────────
    const regSelfLabel = (val) => {
        const map = { R: 'Regular', S: 'Self-Financed', SS: 'Self Support' };
        return map[val] || val || '—';
    };

    const nocTypeLabel = (val) => val || '—';
    const aciteLabel = (val) => val || '—';



    function CourseTable({ title, data, catNameMap, courseNameMap, regSelfLabel, nocTypeLabel }) {
        if (!data || data.length === 0) return null;

        return (
            <>

                <h5 className="mb-3 innerheader-new mt-4">
                    <span>{title}</span>
                </h5>
                <FormikProvider value={formik}>
                    <Form className="form_adjust" onSubmit={formik.handleSubmit} onChange={formik.handleChange}>

                        <div className="table-responsive mt-2">
                            <table className="table table-bordered table-hover mt-2">
                                <thead className="table-success">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Course / Program</th>
                                        <th>Branch / Specialization</th>
                                        <th>Regular / Self-Financed</th>
                                        <th>Affiliation Type</th>

                                        <th>Approved Intake</th>
                                        <th> No of Sections</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index}>
                                            <td className="text-center">{index + 1}</td>
                                            <td>{catNameMap[item?.course_cat_id] || item?.course_cat_id || '—'}</td>
                                            <td>{courseNameMap[item?.course_id] || item?.course_id || '—'}</td>
                                            <td>{regSelfLabel(item?.reg_self)}</td>
                                            <td>{nocTypeLabel(item?.course_noc_type)}</td>

                                            <td className="text-center">{item?.intake || '—'}</td>

                                            <td>
                                                <Field
                                                    as="select"
                                                    name={`courseDetails[${index}].sectionNo`}
                                                    className="form-control"
                                                >
                                                    <option value="">--Select--</option>
                                                    {Array.from({ length: 10 }, (_, i) => (
                                                        <option key={i + 1} value={i + 1}>
                                                            {i + 1}
                                                        </option>
                                                    ))}


                                                </Field>
                                                <ErrorMessage name={`courseDetails[${index}].sectionNo`} component="div" className="text-danger" />

                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot className="table-light">
                                    <tr>
                                        <td colSpan={5} className="text-end fw-bold">Total Approved Intake:</td>
                                        <td className="text-center fw-bold">
                                            {data?.reduce((sum, item) => sum + (parseInt(item?.intake) || 0), 0)}
                                        </td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </Form>
                </FormikProvider >



            </>
        );
    }
    return (
        <>
            <div className="faculty-form-wrapper">
                <div className="faculty-card">
                    <FormikProvider value={formik}>
                        <Form onSubmit={formik.handleSubmit} onChange={formik?.handleChange}>
                            {Clg !== "degree" ? (<>
                                <h5 className="mb-3 innerheader-new"><span>Course Intake Details</span></h5>

                                <FormikProvider value={formik}>
                                    <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form">

                                        <div className="table-responsive mt-3">
                                            <table className="table table-bordered mt-2">
                                                <thead className="table-primary">
                                                    <tr>
                                                        <th>SNO</th>
                                                        <th>Academic Program Type</th>
                                                        <th>Course / Program</th>
                                                        <th>Branch / Specialization</th>
                                                        <th>Regular / Self-Financed</th>
                                                        <th>Permanent / Temporary Affiliation</th>
                                                        <th>Approved Intake</th>
                                                        <th>AICTE App. Ref</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <FieldArray name="courseDetails">
                                                        {(arrayHelpers) => (
                                                            <>
                                                                {formik?.values?.courseDetails?.map((row, index) => (
                                                                    <tr key={index}>

                                                                        <td className="text-center">{index + 1}</td>

                                                                        <td>
                                                                            <Field as="select" className="select-input"
                                                                                name={`courseDetails[${index}].courseGropcode`}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    formik.setFieldValue(`courseDetails[${index}].courseGropcode`, value);
                                                                                    formik.setFieldValue(`courseDetails[${index}].courseType`, '');
                                                                                    formik.setFieldValue(`courseDetails[${index}].courseId`, '');
                                                                                    GetCourseCategory(value, index);
                                                                                }}>
                                                                                <option value="">--Select--</option>
                                                                                {program.map((p, i) => (
                                                                                    <option key={i} value={p.course_group_code}>{p.course_group_desc}</option>
                                                                                ))}
                                                                            </Field>
                                                                            <ErrorMessage name={`courseDetails[${index}].courseGropcode`} component="div" className="text-danger small" />
                                                                        </td>

                                                                        <td>
                                                                            <Field as="select" className="select-input"
                                                                                name={`courseDetails[${index}].courseType`}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    formik.setFieldValue(`courseDetails[${index}].courseType`, value);
                                                                                    formik.setFieldValue(`courseDetails[${index}].courseId`, '');
                                                                                    GetCourses(value, index);
                                                                                }}>
                                                                                <option value="">--Select--</option>
                                                                                {CourseCategory[index]}
                                                                            </Field>
                                                                            <ErrorMessage name={`courseDetails[${index}].courseType`} component="div" className="text-danger small" />
                                                                        </td>

                                                                        <td>
                                                                            <Field as="select" className="select-input" name={`courseDetails[${index}].courseId`}>
                                                                                <option value="">--Select--</option>
                                                                                {course[index]}
                                                                            </Field>
                                                                            <ErrorMessage name={`courseDetails[${index}].courseId`} component="div" className="text-danger small" />
                                                                        </td>

                                                                        <td>
                                                                            <Field as="select" className="select-input" name={`courseDetails[${index}].regSelf`}>
                                                                                <option value="">--Select--</option>
                                                                                <option value="R">Regular</option>
                                                                                <option value="S">Self-Financed</option>
                                                                                <option value="SS">Self Support</option>
                                                                            </Field>
                                                                            <ErrorMessage name={`courseDetails[${index}].regSelf`} component="div" className="text-danger small" />
                                                                        </td>

                                                                        <td>
                                                                            <Field as="select" className="select-input" name={`courseDetails[${index}].courseNocType`}>
                                                                                <option value="">--Select--</option>
                                                                                <option value="Permanent">Permanent</option>
                                                                                <option value="Temporary">Temporary</option>
                                                                                <option value="Conditional">Conditional</option>
                                                                            </Field>
                                                                            <ErrorMessage name={`courseDetails[${index}].courseNocType`} component="div" className="text-danger small" />
                                                                        </td>

                                                                        <td>
                                                                            <Field type="text" name={`courseDetails[${index}].intake`}
                                                                                className="form-control" maxLength={5} onKeyPress={allowNumbersOnly} />
                                                                            <ErrorMessage name={`courseDetails[${index}].intake`} component="div" className="text-danger small" />
                                                                        </td>

                                                                        <td>
                                                                            <Field as="select" className="select-input" name={`courseDetails[${index}].acite`}>
                                                                                <option value="">--Select--</option>
                                                                                <option value="AICTE">AICTE</option>
                                                                                <option value="CHE">CHE</option>
                                                                                <option value="BCI">BCI</option>
                                                                                <option value="PCI">PCI</option>
                                                                            </Field>
                                                                            <ErrorMessage name={`courseDetails[${index}].acite`} component="div" className="text-danger small" />
                                                                        </td>

                                                                        <td className="text-center">
                                                                            {index === 0 && (
                                                                                <button type="button" className="btn btn-success btn-sm"
                                                                                    onClick={() => arrayHelpers.push({
                                                                                        courseGropcode: '', courseType: '', courseId: '',
                                                                                        regSelf: '', courseNocType: '', intake: '', acite: '', campusType: ''
                                                                                    })}>
                                                                                    <VscDiffAdded />
                                                                                </button>
                                                                            )}
                                                                            {index !== 0 && (
                                                                                <button type="button" className="btn btn-danger btn-sm"
                                                                                    onClick={() => handleRemoveRow(arrayHelpers, index)}>
                                                                                    <BiTrash />
                                                                                </button>
                                                                            )}
                                                                        </td>

                                                                    </tr>
                                                                ))}
                                                            </>
                                                        )}
                                                    </FieldArray>
                                                </tbody>
                                            </table>
                                        </div>

                                        <button type="submit" className="btn btn-success btn-sm float-end mt-3">Save</button>
                                        <br /><br /><br />

                                    </Form>
                                </FormikProvider>


                            </>) : (
                                <>


                                    {/* {noUG && noPG && (
                                        <center className="text-danger mt-4 h5">
                                            ***** No Data Found *****
                                        </center>
                                    )}

                                    {!noUG && (
                                        <CourseTable
                                            title="List of UG Courses"
                                            data={ugReportData}
                                            catNameMap={catNameMap}
                                            courseNameMap={courseNameMap}
                                            regSelfLabel={regSelfLabel}
                                            nocTypeLabel={nocTypeLabel}
                                        />
                                    )}
                                    {!noPG && (
                                        <CourseTable
                                            title="List of PG Courses"
                                            data={pgReportData}
                                            catNameMap={catNameMap}
                                            courseNameMap={courseNameMap}
                                            regSelfLabel={regSelfLabel}
                                            nocTypeLabel={nocTypeLabel}
                                        />
                                    )} */}




                                    {noUG && noPG ? (
                                        <center className="text-danger mt-4 h5">
                                            ***** No Data Found *****
                                        </center>
                                    ) : (
                                        <>
                                            {!noUG && (
                                                <CourseTable
                                                    title="List of UG Courses"
                                                    data={ugReportData}
                                                    catNameMap={catNameMap}
                                                    courseNameMap={courseNameMap}
                                                    regSelfLabel={regSelfLabel}
                                                    nocTypeLabel={nocTypeLabel}
                                                />
                                            )}

                                            {!noPG && (
                                                <CourseTable
                                                    title="List of PG Courses"
                                                    data={pgReportData}
                                                    catNameMap={catNameMap}
                                                    courseNameMap={courseNameMap}
                                                    regSelfLabel={regSelfLabel}
                                                    nocTypeLabel={nocTypeLabel}
                                                />
                                            )}
                                            <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                                                {paymentDone ? (
                                                    <div style={{ color: "green", fontWeight: "bold" }}>
                                                        ✅ Already submitted
                                                    </div>
                                                ) : (
                                                    <button
                                                        type="submit"
                                                        className="btn btn-success btn-sm"
                                                    >
                                                        Submit
                                                    </button>
                                                )}
                                            </div>


                                            <br />
                                            <br />
                                            <br />

                                        </>
                                    )}
                                </>
                            )}

                        </Form>
                    </FormikProvider>
                </div>
            </div>
        </>
    );
}

export default CourseIntakeDetails;
